/**
 * The Vibe tenant alert engine's issue codes — one per detector, and one for a
 * detector that cannot look — composed from one file per concern.
 *
 * Every code here is raised by `EvaluateTenantAlertsUseCase` alone, which
 * reports each firing alert on every tick it holds and resolves its fingerprint
 * the tick it clears. No other caller may report them: the engine also retracts
 * them by set difference, so a second reporter's row would be resolved by a tick
 * that never saw it.
 *
 * Each file's header states the fingerprint its codes use, and each code's
 * comment states why it pages or does not.
 *
 * 🔴 RETIRING A DETECTOR KEEPS ITS CODE HERE. The engine retracts every code in
 * this family by set difference on each complete tick, including a code no
 * running detector maps to any more, so a retired detector's open rows are
 * resolved on the first complete tick after the deploy that retires it. A code
 * deleted from this file can no longer be named, and its open rows stay OPEN
 * until someone resolves them by hand — so a code leaves only once no row of it
 * is open.
 */
import type { IssueDefinition } from "../../issue-definition";
import { VIBE_ALERT_EDGE_ISSUES } from "./edge";
import { VIBE_ALERT_ENGINE_ISSUES } from "./engine";
import { VIBE_ALERT_NODE_ISSUES } from "./nodes";
import { VIBE_ALERT_RECONCILE_ISSUES } from "./reconcile";
import { VIBE_ALERT_WORKLOAD_ISSUES } from "./workload";

export const VIBE_TENANT_ALERT_ISSUES = {
  ...VIBE_ALERT_RECONCILE_ISSUES,
  ...VIBE_ALERT_NODE_ISSUES,
  ...VIBE_ALERT_WORKLOAD_ISSUES,
  ...VIBE_ALERT_EDGE_ISSUES,
  ...VIBE_ALERT_ENGINE_ISSUES
} as const satisfies Record<string, IssueDefinition>;
